import {
  Activity,
  CheckCircle2,
  ClipboardList,
  Filter,
  Gauge,
  HardHat,
  MessageSquare,
  Send,
  UserCheck,
} from "lucide-react";
import { SectionHeading } from "../components/SectionHeading";

const STATUSES = ["Açık", "Devam Ediyor", "Saha Doğrulama", "Tamamlandı"];

const TICKETS = [
  {
    id: "İE-241",
    title: "Boru hattı kaçak kontrolü",
    project: "Marmara · Bölge 02",
    assignee: "Saha Ekip 4",
    status: 1,
  },
  {
    id: "İE-238",
    title: "Vana lokasyonu güncelle",
    project: "Akarsu · Bölge 03",
    assignee: "M. Yılmaz",
    status: 0,
  },
  {
    id: "İE-235",
    title: "Yeni branşman çizimi",
    project: "Akarsu · Bölge 11",
    assignee: "Saha Ekip 1",
    status: 2,
  },
  {
    id: "İE-230",
    title: "Müteahhit teslim raporu",
    project: "Marmara · Bölge 05",
    assignee: "B. Demir",
    status: 1,
  },
];

const CREW_PERF = [
  { name: "Saha Ekip 1", open: 7, done: 42, avgHours: "4.2 sa", trend: "+8%" },
  { name: "Saha Ekip 4", open: 12, done: 31, avgHours: "5.6 sa", trend: "−3%" },
  { name: "M. Yılmaz", open: 3, done: 18, avgHours: "2.9 sa", trend: "+14%" },
];

export function Tasks() {
  return (
    <section id="is-takip" className="border-b border-border/60">
      <div className="container py-20 md:py-28">
        <SectionHeading
          eyebrow="İş Emri & Saha Takibi"
          title={
            <>
              İş emrinden saha ekibi performansına <span className="gradient-text">tek pano</span>.
            </>
          }
          description="İş emri yaratma, kullanıcı veya saha ekibine atama, GIS projesiyle bağlama, ekip performansını izleme ve kayıtlı filtre panoları — operasyonel takip için ayrı bir araç gerekmez. Tüm akış aynı haritada, aynı yetki çatısı altında."
        />

        <div className="mt-14 grid gap-10 lg:grid-cols-[1.1fr_1fr]">
          <div className="overflow-hidden rounded-2xl border border-border/70 bg-card shadow-soft">
            <div className="flex items-center justify-between border-b border-border/60 bg-muted/40 px-4 py-3">
              <div className="flex items-center gap-2 text-sm font-medium">
                <ClipboardList className="h-4 w-4" />
                İş Emri Panosu — Akarsu
              </div>
              <div className="flex items-center gap-2 text-xs text-muted-foreground">
                <Filter className="h-3.5 w-3.5" /> Saha · Açık · Bu hafta
              </div>
            </div>
            <div className="grid grid-cols-4 gap-3 p-4">
              {STATUSES.map((status, idx) => (
                <div key={status} className="space-y-2">
                  <div className="flex items-center justify-between">
                    <div className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">
                      {status}
                    </div>
                    <span className="rounded-full bg-muted px-1.5 text-[10px] text-muted-foreground">
                      {TICKETS.filter((t) => t.status === idx).length}
                    </span>
                  </div>
                  <div className="space-y-2">
                    {TICKETS.filter((t) => t.status === idx).map((t) => (
                      <div
                        key={t.id}
                        className="rounded-lg border border-border/60 bg-background p-3 text-left"
                      >
                        <div className="text-[10px] font-medium uppercase tracking-wider text-muted-foreground">
                          {t.id}
                        </div>
                        <div className="mt-1 text-sm font-medium">{t.title}</div>
                        <div className="mt-2 text-xs text-muted-foreground">{t.project}</div>
                        <div className="mt-2 text-[11px] text-foreground/70">{t.assignee}</div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="space-y-6">
            {[
              {
                icon: Send,
                title: "İş emri yaratma ve atama",
                desc: "Ofisten tek tıkla iş emri açın; bir kullanıcıya veya saha ekibine atayın, GIS projesinin ilgili bölgesine bağlayın, son tarih ve özel alanları doldurun. Saha ekibi atandığı emri telefonundan açar.",
              },
              {
                icon: HardHat,
                title: "Saha ekiplerinin yükünü tek bakışta görme",
                desc: "Hangi ekibin üzerinde kaç açık iş emri var, hangi bölgede yoğunluk birikmiş, kim hangi statüde takılmış — harita üstünde renkli yoğunluk göstergesiyle anlık olarak görünür.",
              },
              {
                icon: ClipboardList,
                title: "Kurumun iş akışına göre statü ve özel alanlar",
                desc: "Statüler ve özel alanlar yönetici tarafından tanımlanır; kanban kolonları otomatik bu yapıdan üretilir. Hazır şablon beklemezsiniz, kendi sürecinizi modellersiniz.",
              },
              {
                icon: MessageSquare,
                title: "Yorum, ek dosya, aktivite kaydı",
                desc: "Her iş emrinde yorum ve dosya geçmişi; statü değişikliği, atama ve kapatma adımları izlenebilir aktivite kaydına düşer — denetim sorulduğunda tüm zincir hazır.",
              },
              {
                icon: Filter,
                title: "Kayıtlı panolar ve paylaşım",
                desc: "Aktif filtre konfigürasyonunu pano olarak kaydedin, ekip veya kullanıcılarla paylaşın. Pano sadece bir filtre olduğu için ek yetki gerektirmez.",
              },
              {
                icon: CheckCircle2,
                title: "GIS projesiyle bağ",
                desc: "Bir iş emri Mevcut Altyapı veya Altyapı Projesi'ne bağlanır; ilgili proje sayfasından bağlı emirler tek tıkla görünür, harita üstünde işaretlenir.",
              },
            ].map(({ icon: Icon, title, desc }) => (
              <div key={title} className="flex gap-4">
                <div className="grid h-10 w-10 shrink-0 place-items-center rounded-lg bg-muted">
                  <Icon className="h-5 w-5 text-foreground/80" />
                </div>
                <div>
                  <div className="font-medium">{title}</div>
                  <p className="mt-1 text-sm text-muted-foreground">{desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <PerformanceMonitoring />
      </div>
    </section>
  );
}

function PerformanceMonitoring() {
  return (
    <div className="mt-16 overflow-hidden rounded-2xl border border-border/70 bg-card">
      <div className="grid gap-0 lg:grid-cols-[1fr_1.1fr]">
        <div className="p-7 md:p-9">
          <div className="inline-flex items-center gap-2 rounded-full border border-primary/30 bg-primary/10 px-2.5 py-1 text-[11px] font-semibold uppercase tracking-[0.16em] text-primary">
            <Gauge className="h-3 w-3" />
            Performans İzleme
          </div>
          <h3 className="mt-4 text-balance text-2xl font-semibold tracking-tight md:text-[1.7rem]">
            Saha ekibi ve bireysel kullanıcı karneleri.
          </h3>
          <p className="mt-3 text-pretty text-base text-muted-foreground">
            Yöneticilerin "bu hafta hangi ekip nereye yetişti, kim hangi ortalamada çalışıyor,
            nereye takılıyoruz?" sorularına cevap veren izleme ekranları.
          </p>

          <ul className="mt-5 space-y-2 text-sm text-muted-foreground">
            {[
              {
                icon: UserCheck,
                t: "Bireysel performans karnesi",
                d: "Her enterprise üyesi için tamamlanan iş emri sayısı, ortalama kapanış süresi, açık emir yükü ve trend.",
              },
              {
                icon: HardHat,
                t: "Saha ekibi monitörü",
                d: "Ekip bazında yük dağılımı, bölgesel yoğunluk, gecikmeli emirler ve haftalık üretkenlik kıyaslaması.",
              },
              {
                icon: Activity,
                t: "Operasyonel sağlık panosu",
                d: "Açık/kapalı dengesi, ortalama kapanış süresi, statü darboğazları — tek bakışta operasyonun sağlığı.",
              },
            ].map(({ icon: Icon, t, d }) => (
              <li key={t} className="flex gap-3">
                <Icon className="mt-0.5 h-4 w-4 shrink-0 text-foreground/70" />
                <div>
                  <span className="font-medium text-foreground">{t}.</span> {d}
                </div>
              </li>
            ))}
          </ul>
        </div>

        <div className="border-t border-border/60 bg-muted/30 p-7 md:p-9 lg:border-l lg:border-t-0">
          <div className="mb-4 flex items-center justify-between">
            <div className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">
              Bu hafta
            </div>
            <div className="text-xs text-muted-foreground">Akarsu enterprise</div>
          </div>
          <div className="space-y-2.5">
            {CREW_PERF.map((c) => {
              const total = c.open + c.done;
              const donePct = (c.done / total) * 100;
              const positive = c.trend.startsWith("+");
              return (
                <div key={c.name} className="rounded-xl border border-border/60 bg-background p-4">
                  <div className="flex items-center justify-between">
                    <div className="text-sm font-medium">{c.name}</div>
                    <span
                      className={
                        "rounded-full px-2 py-0.5 text-[11px] font-medium " +
                        (positive
                          ? "bg-emerald-500/15 text-emerald-700 dark:text-emerald-300"
                          : "bg-amber-500/15 text-amber-700 dark:text-amber-300")
                      }
                    >
                      {c.trend}
                    </span>
                  </div>
                  <div className="mt-3 grid grid-cols-3 gap-3 text-xs">
                    <KPI label="Açık" value={c.open} />
                    <KPI label="Kapalı" value={c.done} />
                    <KPI label="Ort. süre" value={c.avgHours} />
                  </div>
                  <div className="mt-3 h-1.5 w-full overflow-hidden rounded-full bg-muted">
                    <div className="h-full bg-primary" style={{ width: `${donePct}%` }} />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

function KPI({ label, value }: { label: string; value: number | string }) {
  return (
    <div>
      <div className="text-[10px] uppercase tracking-wider text-muted-foreground">{label}</div>
      <div className="mt-0.5 text-base font-semibold">{value}</div>
    </div>
  );
}
